import React from 'react'
import ScratchPixiApp from '../scratch-game/pixi-app'

const ScratchCoin = () => {
    return (

        <div>
            <ScratchPixiApp />
        </div>
    )
}

export default ScratchCoin